export const projects = [
  {
    slug: 'casa-atalaya-santo-domingo',
    name: 'Casa Atalaya',
    zone: 'Santo Domingo',
    category: 'Residencial',
    year: '2026',
    area: '166.41 m²',
    description:
      'Vivienda unifamiliar de volúmenes horizontales y vanos generosos, pensada para captar luz natural y enmarcar las vistas hacia la sierra.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/a35169919625e63471d6f3f94780a832.jpeg',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/94f16636c9e5cb5456b862422a246061.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/6637118e01078740068689fd63e44c59.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/53c20d2f61127d60bc4463999874e89b.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/d607221ca55184582f6c56292a55288c.jpeg',
    ],
    process: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/785ab8c6504c20746171cf2bfe95803d.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/7fd069f0e5a9e29bdc649c0895eaae23.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/8d895592d9e7c6a9bdb5fdc39a1d1fa2.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/f69afe05c7caec1daaf41494fca62977.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/c0ec69b691bd961e80f58550e75868ae.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/b28b36dc8db8189c0e0653c64eba5cbe.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/5dd516ba4808dd3c9fa52ec6b5b2c038.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/3e4e429169074ef06cea1e2a00c2e461.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/697d340cf01b586b57d77ddcc5c952c1.jpeg',
    ],
    featured: true,
  },
  {
    slug: 'casa-umbral',
    name: 'Casa Umbral',
    zone: 'Soledad de Graciano Sánchez',
    category: 'Residencial',
    year: '2021',
    area: '168.5 m²',
    description:
      'Remodelación integral de vivienda existente, reordenando el programa interior para abrir los espacios comunes hacia el patio central.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/ec0294d1868bd136375f129f071c23b7.jpeg',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/8b71fad60b696bf55cc77d2717a2c088.png',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/ba8073e967e73faf883de3f9d6d048be.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/44f5d053332e2ddc5ef48c05b610e6f3.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/74e00cd9e0afcfabc07047234182fcf0.jpeg',
    ],
    process: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/e1531d4486712eb06af3909eed3cec77.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/ab549498c99150ec553c8ac9e68406da.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/02dd6a57f478655d848a96662ac7c96d.jpeg',
    ],
    featured: true,
  },
  {
    slug: 'patio-de-barro',
    name: 'Patio de Barro',
    zone: 'San Marcos, SLP',
    category: 'Comercial',
    year: '2024',
    area: '110.4 m²',
    description:
      'Restaurante con patio interior como protagonista, materiales cálidos y una circulación clara entre cocina, barra y mesas.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/d560b264ca0e5169e55190fe9c348c2e.jpeg',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/4f6b0f508a1ad9f8aa089d1dda7b52b6.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/b50bdd559368f8879178daa079cc4afc.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/d2484e7228ba00e71a0484232d9e5baf.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/28c076034d560409ccd2cd0d919a1f2b.jpeg',
    ],
    process: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/4c6b71a6944ab976718966418d3003d6.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/ce89d86fcff3497207f57a38182b85fb.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/83f5dba5e4557a463dd8dcf767f5d5f6.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/b0abde79c9cc41e421bfa582cd42ed98.jpeg',
    ],
    featured: true,
  },
  {
    slug: 'casa-cascada',
    name: 'Casa Cascada',
    zone: 'San Miguel de la Colina, SLP',
    category: 'Residencial',
    year: '2023',
    area: '160 m²',
    description:
      'Vivienda organizada alrededor de un patio con alberca, donde una cascada de agua se convierte en el elemento protagonista y articula la relación entre el interior y el exterior. Construcción de 160 m² sobre un terreno de 221.49 m².',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/c8f9bd29e64d0fd5e2d11b61425b2e71.png',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/cb6ddd46a91557a833e01384c515ddfa.png',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/676255d1cea2e2148a93c43a6a6c0584.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/790ad8cb3cb91dfdf883bf28202f0333.jpeg',
    ],
    featured: false,
  },
  {
    slug: 'aurea-departamentos',
    name: 'Aurea Departamentos',
    zone: 'San Luis Potosí, SLP',
    category: 'Residencial',
    year: '2025',
    area: '— m²',
    description:
      'Edificio de departamentos de volumetría limpia y lenguaje sobrio, con celosías y ventanales que filtran la luz y balcones con vegetación que abren los espacios comunes hacia la calle.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/c3531d49f1561e018704312a128e8d7a.png',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/f5760ed8e8c5b37f9df4ba7ba1c143e2.png',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/e8142d8a715ef04a5f777d5f6dc726ca.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/79ebd93c624d455705a908d76c2a94cf.jpeg',
    ],
    process: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/7a945ddd7e3dd654d65754eb21dafb99.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/e5acfd0e65ea037192f65d7150061304.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/dfe211a21a0bc12cd12905f1e6a63618.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/8c1590d07b6fd3ce010ed93939387858.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/a0d8d845cea7dad0be3e0ff203f009da.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/ddffa976f2a4253b46d5b5d18048b3f7.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/fde45e6b9ad018ee7ffb6a7e1a306c27.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/f9619744e00645fc6a2a4dd7b121d7e5.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/a08712980499d4266950ccb5dfb537e7.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/52c2343b6d127a48587b7d9abab36381.jpeg',
    ],
    featured: false,
  },
  {
    slug: 'casa-alba',
    name: 'Casa Alba',
    zone: 'San Luis Potosí, SLP',
    category: 'Residencial',
    year: '2024',
    area: '— m²',
    description:
      'Vivienda de esquina con fachada de líneas continuas y esquinas curvas, donde los vanos iluminados y una celosía vertical marcan la entrada; en el interior, la cocina y el comedor se abren alrededor de una barra que organiza la vida diaria.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/8fc1782361dc50b686553a287dbfc8c5.png',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/96ec488fca06f1c37f323344037492b9.jpeg',
    ],
    featured: false,
  },
  {
    slug: 'casa-barro',
    name: 'Casa Barro',
    zone: 'San Luis Potosí, SLP',
    category: 'Residencial',
    year: '2024',
    area: '— m²',
    description:
      'Vivienda de esquina donde el ladrillo recobrado se convierte en protagonista: una celosía iluminada sobre la cochera y un volumen de cantera que se pliega hacia la calle, tejiendo el encuentro entre el interior y el barrio.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/7e33aeb050d27d39bd32833096735053.jpeg',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/7e33aeb050d27d39bd32833096735053.jpeg',
    ],
    featured: false,
  },
  {
    slug: 'casa-mosaico',
    name: 'Casa Mosaico',
    zone: 'San Luis Potosí, SLP',
    category: 'Residencial',
    year: '2024',
    area: '— m²',
    description:
      'Vivienda articulada alrededor de un patio interior donde el piso de mosaico hidráulico y la vegetación son protagonistas; una celosía de luz filtra el sol hacia los pasillos y el baño apuesta por texturas oscuras y detalles cálidos.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/6a8d62ce10be75fb2af728ed41edb64b.jpeg',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/167bd365ab54caee5ec3effe10082932.jpeg',
    ],
    featured: false,
  },
  {
    slug: 'departamentos-villa-hermosa',
    name: 'Departamentos Villa Hermosa',
    zone: 'San Luis Potosí, SLP',
    category: 'Residencial',
    year: '2024',
    area: '— m²',
    description:
      'Edificio de departamentos que combina volúmenes de concreto y barro con celosías de ladrillo que filtran la luz del poniente; al centro, un patio con jardín y un árbol de flores naranjas articula la vida en común, mientras cada unidad se resuelve con maderas cálidas en el interior.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/eb80f1af76a92ee6abc7ead6e4f903d8.jpeg',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/696f4d9c7f9fa14c51d04e8029d637e4.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/f0c6e68b31cb06ff5652f6233b7554de.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/841e352dbf831ee6aa1f1f18faa2b4d5.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/0b68711ad3dfcdc77a7244cfa39e9e31.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/5bd5f6ae6c4c865a0ff5cfc386c3ab97.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/7a6d65c457246c6f0a3269ce9d6570e2.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/98fbbb5c355762c71a4667be351a64cd.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/12da71ab679b7ee64e1356b8501ef0ec.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/6198578544bc6466946a1bed7d3c221d.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/cfbd1efff89e74aba4ede07ddbbaa5d8.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/a90415640e10cc72b5ab39ffa42326ec.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/4a2e18620ad831f78075946e4350bd7d.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/9607616469194d691946067607e57163.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/de0b3b377c44ee5bc3578c4c240309e5.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/86aaec576cc12b66936c037b6fda12ad.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/34756493c8521ac1455ef3df25159341.jpeg',
    ],
    featured: false,
  },
  {
    slug: 'patio-sendero',
    name: 'Patio Sendero',
    zone: 'San Luis Potosí, SLP',
    category: 'Interior',
    year: '2024',
    area: '— m²',
    description:
      'Diseño de un patio de estar y su recorrido: una pérgola de madera con luces colgantes cubre el área de lounge, mientras un sendero de losas de piedra entre grava y jardín guía el paso junto a un muro de celosía que filtra la luz.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/5cd76c78a62376219fc156decb1533da.jpeg',
    gallery: [
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/16b38a6a3f3531a2125506774897ebd0.jpeg',
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/139ead79fd68eedd7cb1c9c6533f4873.jpeg',
    ],
    featured: false,
  },
];